import { useMemo } from 'react';
import { Settings, LinkIcon, Info } from 'lucide-react';
import { useCurrentStateAndParams } from '@uirouter/react';

import { AttachmentsDataTables } from '@/react/portainer/policies/DetailView/AttachmentsDataTables/AttachmentsDataTables';

import { PageHeader } from '@@/PageHeader';
import { Tab, WidgetTabs, useCurrentTabIndex } from '@@/Widget/WidgetTabs';

import { usePolicy } from '../queries/usePolicy';

import { PolicyHeader } from './PolicyHeader';
import { ConfigTab } from './ConfigTab';
import { PolicyDetailsTab } from './PolicyDetailsTab';

export function PolicyDetailView() {
  const { params } = useCurrentStateAndParams();
  const policyId = Number(params.id);
  const policyQuery = usePolicy(policyId);
  const policy = policyQuery.data;
  const policyName = policy?.Name ?? 'Policy';

  const tabs: Array<Tab> = useMemo(
    () => [
      {
        name: 'Info',
        icon: Info,
        widget: <PolicyDetailsTab policyId={policyId} />,
        selectedTabParam: 'info',
      },
      {
        name: 'Attachments',
        icon: LinkIcon,
        widget: <AttachmentsDataTables policyId={policyId} />,
        selectedTabParam: 'attachments',
      },
      {
        name: 'Settings',
        icon: Settings,
        widget: policy ? <ConfigTab policy={policy} /> : null,
        selectedTabParam: 'settings',
      },
    ],
    [policyId, policy]
  );

  const currentTabIndex = useCurrentTabIndex(tabs);

  return (
    <>
      <PageHeader
        title={policyName}
        breadcrumbs={[
          { label: 'Fleet Governance Policies', link: 'portainer.policies' },
          policyName,
        ]}
        reload
      />
      <div className="row">
        <div className="col-sm-12">
          <PolicyHeader policy={policy} isLoading={policyQuery.isLoading} />
        </div>
      </div>
      <WidgetTabs tabs={tabs} currentTabIndex={currentTabIndex} />
      {tabs[currentTabIndex].widget}
    </>
  );
}
